export default {
  dataListing: state => state.dataListing,
  countDataListing: state => state.countDataListing,
  kpis: state => state.kpis,
  dataRecords: state => state.dataRecords,
  filter: state => state.filter,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  retrospectiveDay: state => state.retrospectiveDay,
  startDate: state => state.startDate,
  endDate: state => state.endDate,
  locations: state => state.locations,
  filterBy: state => state.filterBy,
  filterByOptions: state => state.filterByOptions,
  typeBy: state => state.typeBy,
  breakdownSummary: state => state.breakdownSummary,
  inQueue: state => state.inQueue,
  inProgress: state => state.inProgress,
  completed: state => state.completed,
  technician: state => state.technician,
  tools: state => state.tools
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/getters.js